"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPropertyFeature = void 0;
var ListPropertyFeature;
(function (ListPropertyFeature) {
    ListPropertyFeature[ListPropertyFeature["BALCONY"] = 0] = "BALCONY";
    ListPropertyFeature[ListPropertyFeature["TERRACE"] = 1] = "TERRACE";
    ListPropertyFeature[ListPropertyFeature["ROOFTOP"] = 2] = "ROOFTOP";
    ListPropertyFeature[ListPropertyFeature["GARDEN"] = 3] = "GARDEN";
    ListPropertyFeature[ListPropertyFeature["MAIDS_ROOM"] = 4] = "MAIDS_ROOM";
    ListPropertyFeature[ListPropertyFeature["CAR_PARK"] = 5] = "CAR_PARK";
    ListPropertyFeature[ListPropertyFeature["PRIVATE_POOL"] = 6] = "PRIVATE_POOL";
})(ListPropertyFeature = exports.ListPropertyFeature || (exports.ListPropertyFeature = {}));
